import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Checkbox } from 'sarsaparilla';
import { ActivityProps } from '../../props/activity';
import { getRef, addChange, clearChange } from '../../actions/changes';

const propTypes = {
    activity: ActivityProps,
    value: PropTypes.shape({
        activityId: PropTypes.number,
        assetId: PropTypes.string,
        name: PropTypes.string
    }),
    activityType: PropTypes.string
};

const defaultProps = {
    value: null
};

const ActivityOption = ({
    activityType,
    activity,
    value
}) => {
    const [ref, setRef] = useState(null)
    const [isChecked, toggleSelection] = useState(value !== null);
    const dispatch = useDispatch();

    useEffect(() => {
        setRef(dispatch(getRef(activityType, value || {})));
    }, []);

    const handleChange = (newIsChecked) => {
        toggleSelection(newIsChecked);
        if (newIsChecked && value === null) {
            dispatch(addChange(ref, { activityId: activity.id }));
        }
        else if (value !== null) {
            dispatch(addChange(ref, { _delete: true }));
        }
        else {
            dispatch(clearChange(ref));
        }
    }

    return (
        <Checkbox
            id={activity.name}
            label={activity.name}
            onChange={(e) => handleChange(e.target.checked)}
            value="controlled"
            isChecked={isChecked} />
    );
}

ActivityOption.propTypes = propTypes;
ActivityOption.defaultProps = defaultProps;

export default ActivityOption;
